import React, { useState } from "react";

import {
    faPenToSquare,
    faTrash,
    faEye,
    faToolbox
} from "@fortawesome/free-solid-svg-icons";

import Swal from 'sweetalert2'

const RRChecklist = ({checklist, i, FontAwesomeIcon, setChecklistToModify, setShowABM, eliminarChecklist = () => console.log("Eliminar checklist"), actualizarChecklistList, handleLookInfo = () => console.log('handeLookInfo'), getCheckByID}) => {

    const handleClickModify = async() => {
        let res = await getCheckByID(checklist._id);
        if(res?.data?.checklist != undefined){
            setChecklistToModify(res?.data?.checklist);
            setShowABM(false);
        }
    }

    const handleClickDelete = async () => {
        Swal.fire({
            title: `Está seguro que desea eliminar la checklist ${checklist.codigo}?`,
            showDenyButton: true,
            confirmButtonText: 'Sí, estoy seguro',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                eliminarChecklist(checklist)
                .then(res => {
                    if(res.data?.deleted !== undefined && res.data.deleted == true ){
                        Swal.fire({
                            title: `${res.data.message}`,
                            icon: 'success',
                            showConfirmButton: true,    
                            allowEnterKey: true
                        });
                        setShowABM(true);
                        setChecklistToModify({});
                        actualizarChecklistList();
                    }
                })
            } 
        })
    }

    return <div className="checklistRow">
        <div className="infoContainer">
            <FontAwesomeIcon icon={faToolbox} className="rrIcon" id="primaryIcon"/>
            <div className="infoDiv">
                <h6>Código Checklist:</h6>
                <label id="codigoLabel">{checklist.codigo}</label>
            </div>
            <div className="infoDiv">
                <h6>Nombre Checklist:</h6>
                <label>{checklist.name}</label>
            </div>
            <div className="infoDiv">
                <h6>Tipo Activo:</h6>
                <label>{checklist.tipAct}</label>
            </div>
        </div>
        <div className="funcionesDiv">
            <FontAwesomeIcon icon={faEye} className="rrIcon" onClick={()=> handleLookInfo(checklist)}/>
            <FontAwesomeIcon icon={faPenToSquare} onClick={() => handleClickModify()} className="rrIcon"/>
            <FontAwesomeIcon icon={faTrash} className="rrIcon" onClick={() => handleClickDelete()}/>
        </div>  
    </div>

}

export default RRChecklist;